module.exports = __webpack_public_path__ + "static/IMG-1387-ef9951e092c5caffb5edf82f254bed94.jpg";